import { ApiBind, Common } from './common.model';

/**
 * 広告リクエストのパラメータを表すモデル
 *
 * @exports
 *
 */
export class Parameter extends Common {
    @ApiBind({ column: 'index' })
    index: number;

    @ApiBind({ column: 'label' })
    label: string;

    @ApiBind({ column: 'key' })
    key: string;

    @ApiBind({ column: 'value' })
    value: string;
}
